import { Component, HostListener, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { displayPayLink, removeIFrame } from '../../assets/dollarpay.js'

import { Router, ActivatedRoute } from '@angular/router';

import { StorageService } from '../services/StorageService';

import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-fetch-data',
  templateUrl: './fetch-data.component.html'
})
export class FetchDataComponent {
  public forecasts: WeatherForecast[];


  amount = '';
  dynamicWidth = 150;
  loading: boolean = false;
  start: boolean = true;
  success: boolean = false;

  source;

  vendor;
  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService, private localStorage: StorageService
  ) {

    this.source = decodeURI(this.activeRoute.snapshot.params['id']);
    this.ipAddress = this.localStorage.get("IpAddress") || '';

    this.fetchVendor();



  }



  note = '';

  ipAddress;

  generateLinkSessionId() {

    this.start = false
    this.loading = true;

    const subRequest = {
      first_name: 'Unknown',
      last_name: 'Unknown',
      email: 'Unknown',
      phone: 'Unknown',
      dob: '',
      customer_identifier: ''
    }

    const request = {
      ip_address: this.ipAddress,
      description: this.note,
      final_amount: Number(this.amount),
      vendor_identifier: this.vendor.identifier,
      application_fee_amount: 0.00,
      transaction_descriptor: this.note,
      customer_identity: subRequest
    }


    this.httpService.post<any>('store/generate-transaction-session-identifier', request, false).subscribe(
      resp => {

        displayPayLink(JSON.parse(resp.message).sessionId);
        this.loading = false;

      },
      error => {
        this.loading = false;
        console.log(error);

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }


  //show() {



  //  if (this.amount > 0 && this.note != '') {
  //    this.generateLinkSessionId()
  //  }




    




  //}




  fetchVendor() {

    this.loading = true;

    const request = {
      VendorUsername: this.source
    }



    this.httpService.post<any>('Store/fetch-vendor-details-by-username', request, false).subscribe(
      resp => {
        this.vendor = JSON.parse(resp.message);
        this.loading = false;

      },
      error => {
        this.loading = false;

        console.log(error);

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });

}



  transactionId;

  //@HostListener('window:message', ['$event'])
  //onMessage(event) {

  //  //console.log(event)
  //  const data = JSON.parse(event.data);

  //  if (data.message == 'success') {

  //    this.transactionId = data.transactionId;

  //    this.start = false;
  //    this.loading = false;
  //    this.success = true;
  //    removeIFrame();


  //  }




  //  if (data.message == 'terminated') {
  //    console.log("termination")
  //    removeIFrame();


  //  }
  //};






}

interface WeatherForecast {
  date: string;
  temperatureC: number;
  temperatureF: number;
  summary: string;
}
